import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import View from '@bubble-ui/primitive-view';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var AvatarGroup = _ref => {
  var {
    children,
    hasBorder = true,
    imgResizeMode = 'contain',
    max = 5,
    size,
    stackingMode = 'last-on-top',
    UNSAFE_containerProps
  } = _ref;
  var {
    containerStyle,
    itemStyle
  } = getDefaultStyleSheet();
  var total = React.Children.count(children);
  var slicedChildren = React.Children.toArray(children).slice(0, max);
  var indexOfLastItem = max - 1;
  return /*#__PURE__*/React.createElement(View, _extends({
    style: containerStyle
  }, UNSAFE_containerProps), slicedChildren.map((child, i) => /*#__PURE__*/React.createElement(View, {
    key: "v-".concat(child.key),
    style: i !== 0 ? _objectSpread({
      zIndex: stackingMode === 'first-on-top' ? total - i : 0
    }, itemStyle) : {
      zIndex: stackingMode === 'first-on-top' ? total - i : 0
    }
  }, /*#__PURE__*/React.cloneElement(child, {
    amount: total > max && i === indexOfLastItem ? "+".concat(total - max + 1) : undefined,
    hasBorder,
    imgResizeMode,
    size
  }))));
};
AvatarGroup.displayName = 'AvatarGroup';
export { AvatarGroup };
//# sourceMappingURL=index.js.map